/**
 * 통계 서비스 데이터
 * 상점, 허브 공통
 * 서버에 던질 데이터만 선언한다.
 */
export class GetStats {
    /** 허브 또는 상점 타입 */
    resourceType = 'store';
    /** 통계 타입 */
    statsType = 'daily';
    /** 선택한 허브 아이디 */
    selectedHub = 'ALL';
    /** 선택한 상점 아이디 */
    selectedStore = 'ALL';
    /** 기간 */
    date;
    constructor(data) {
        Object.assign(this, data);
    }
    /**
     * 서버 요청 데이터 생성
     */
    createReqBody() {
        // 허브 통계 (일별, 월별, 시간대별, 요일별)
        if (this.resourceType === 'hub') {
            return {
                hubId: this.selectedHub,
                from: this.date[0],
                to: this.date[1],
                orderDirectionType: 'ORDER',
                orderAgencyType: 'ALL',
            };
        }
        // 상점 통계
        return {
            hubCode: this.selectedHub,
            storeCode: this.selectedStore,
            date: this.date,
        };
    }
}
